import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Response} from '@angular/http';
import {CONSTANTS} from '../../../cadens.constants';
import {ListeChoixService} from '../../../shared/ListeChoix/listeChoix.service';
import {ListeChoix} from '../../../shared/ListeChoix/listeChoix.model';
import {JhiLanguageService} from 'ng-jhipster';
import {Preavis} from './preavis.model';
import {PreavisService} from './preavis.service';

@Component({
    selector: 'jhi-preavis-component',
    templateUrl: './preavis.component.html'
})
export class PreavisComponent implements OnInit {

    @Input() listePreavis: Preavis[];
    @Input() preavisModifEnabled: boolean;
    @Input() dateLimitePreavis: number;
    @Output() listPreavisChange: EventEmitter<Preavis[]> = new EventEmitter();
    listeCommentaires: ListeChoix[];
    listeChoixPreavis: ListeChoix[];
    constants = CONSTANTS;
    currentLang: string;
    currentPreavisCode: string;

    constructor(private listeChoixService: ListeChoixService,
                private jhiLanguageService: JhiLanguageService,
                private preavisService: PreavisService) {
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }

    ngOnInit() {
        this.listeChoixService.query({type: CONSTANTS.PREAVIS}).subscribe(
            (res: Response) => {
                this.listeChoixPreavis = res.json();
            });
        this.listeChoixService.query({type: CONSTANTS.COMMENTAIRE}).subscribe(
            (res: Response) => {
                this.listeCommentaires = res.json();
            });
    }

    choosePreavis(preavis: Preavis, choixPreavis: ListeChoix) {
        if (preavis.choix != null && preavis.choix.code == choixPreavis.code) {
            preavis.choix = null;
        } else {
            preavis.choix = choixPreavis;
        }
        if (preavis.dateCreation == null) {
            preavis.dateCreation = preavis.dateModification = new Date();
        } else {
            preavis.dateModification = new Date();
        }


        this.listPreavisChange.emit(this.listePreavis);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/preavis/preavis.component.ts